import { useSearchParams } from 'react-router-dom'

const tabs: Record<string, string> = {
  contact: 'contact', contacts: 'contact',
  action: 'actions', actions: 'actions',
  note: 'note', notes: 'note',
  order: 'order', orders: 'order',
}
const queryNames: Record<string, string> = { contact: 'contact', actions: 'action', note: 'note', order: 'order' }

export function useCustomerTab() {
  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = tabs[searchParams.get('t') ?? ''] ?? 'contact'
  function selectTab(key: string | null) {
    if (!key || !queryNames[key]) return
    setSearchParams(current => {
      const next = new URLSearchParams(current)
      next.set('t', queryNames[key])
      return next
    }, { replace: true })
  }
  return { activeTab, selectTab }
}
